var $ = require('jquery');
var Retina = require('retina.js').Retina;

$(document).ready(function() {
  Retina.init(window);
});
